module.exports = __webpack_public_path__ + "media/4-2.8ca3637b.mp3";